import type { JSX } from 'preact';

export const APP_STORE_URL =
  'https://apps.apple.com/app/shotmeal-calorie-tracker/id6782473470';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.shotmeal.app';

type Props = {
  appStoreUrl?: string;
  playStoreUrl?: string;
};

export function StoreBadges({
  appStoreUrl = APP_STORE_URL,
  playStoreUrl = PLAY_STORE_URL,
}: Props) {
  return (
    <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
      <Badge platform="App Store" icon={<AppleIcon />} url={appStoreUrl} />
      <Badge platform="Google Play" icon={<GooglePlayIcon />} url={playStoreUrl} />
    </div>
  );
}

function Badge({
  platform,
  icon,
  url,
}: {
  platform: string;
  icon: JSX.Element;
  url?: string;
}) {
  const content = (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        padding: '12px 18px',
        background: 'var(--hero-bg)',
        color: 'var(--hero-fg)',
        borderRadius: 14,
        fontFamily: 'var(--font-ui)',
        fontSize: 14,
        fontWeight: 600,
        boxShadow: 'var(--shadow-card)',
        textDecoration: 'none',
      }}
    >
      <span
        aria-hidden
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 22,
          height: 22,
          color: 'var(--hero-fg)',
        }}
      >
        {icon}
      </span>
      <span>{platform}</span>
    </span>
  );
  if (!url) return content;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: 'none' }}
    >
      {content}
    </a>
  );
}

function AppleIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
      <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
    </svg>
  );
}

function GooglePlayIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
      <path d="M3 20.5V3.5c0-.59.34-1.11.84-1.35L13.69 12 3.84 21.85c-.5-.25-.84-.76-.84-1.35zm13.81-5.38L6.05 21.34l8.49-8.49 2.27 2.27zm3.35-4.31c.34.27.59.69.59 1.19 0 .5-.22.92-.57 1.18l-2.29 1.32-2.5-2.5 2.5-2.5 2.27 1.31zM6.05 2.66l10.76 6.22-2.27 2.27-8.49-8.49z" />
    </svg>
  );
}
